// extracted by mini-css-extract-plugin
module.exports = {"star":"styles__star___1U8HY","selected":"styles__selected___3Zyr3 styles__star___1U8HY","name":"styles__name___3Kpkg"};